import React, { useState } from "react";
import PopUp from "../../components/PopUp";
import Input from "../../components/Input";
import { useNavigate } from "react-router-dom";
import { House, QrCode, User, KeyRound, UserPen, LogOut } from "lucide-react";
import Alert from "../../components/Alert";

export let infoUtente = {};

const Footer = () => {
    const navigate = useNavigate();
    const [isProfiloOpen, setIsProfiloOpen] = useState(false);
    const [isEditProfileOpen, setIsEditProfileOpen] = useState(false);
    const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
    const [nome, setNome] = useState(infoUtente["Nome"] || null);
    const [cognome, setCognome] = useState(infoUtente["Cognome"] || null);
    const [email, setEmail] = useState(infoUtente["Email"] || null);
    const [vecchiaPassword, setVecchiaPassword] = useState("");
    const [nuovaPassword, setNuovaPassword] = useState("");
    const [confermaPassword, setConfermaPassword] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    const handleLogout = () => {
        document.cookie.split(";").forEach(cookie => {
            const name = cookie.split("=")[0].trim();
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
        });
        navigate('/');
    };

    const checkEmail = async () => {
        if (email === "" || email === infoUtente["Email"]) return;

        try {
            const response = await fetch('/checkEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: email }),
            });
            if (response.status === 401) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setEmail(infoUtente['Email']);
            }
            else if (response.status !== 200) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setEmail(infoUtente['Email']);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante il controllo dell'email", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            setEmail(infoUtente['Email']);
        }
    };

    const confirmPopUpProfilo = async () => {
        if (nome === "" || cognome === "" || email === "") {
            setAlertInfo({ type: "warning", text: "Tutti i campi sono obbligatori (*)", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }

        try {
            const response = await fetch('/aggiornaUtente', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ID: infoUtente['ID'], Nome: nome, Cognome: cognome, Email: email })
            });

            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
            }
            else {
                window.location.reload();
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante l'aggiornamento del profilo", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }
    };

    const checkPassword = (password) => {
        let check = true;
        const uppercasePattern = /[A-Z]/;
        const lowercasePattern = /[a-z]/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
        const numberPattern = /[0-9]/;

        if (!uppercasePattern.test(password)) {
            check = false;
        }
        if (!lowercasePattern.test(password)) {
            check = false;
        }
        if (!specialCharPattern.test(password)) {
            check = false;
        }
        if (!numberPattern.test(password)) {
            check = false;
        }
        if (password.length < 8) {
            check = false;
        }

        return check;
    };

    const confirmPopUpPassword = async () => {
        //Contollo la vechia password
        try {
            const response = await fetch('/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: infoUtente["Email"], Password: vecchiaPassword, CodiceDispositivo: "ignore" }),
            });
            const data = await response.json();
            if (response.status === 500) {
                setAlertInfo({ type: "error", text: data.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setVecchiaPassword('');
                return;
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante il controllo della vecchia password", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            setVecchiaPassword('');
            return;
        }

        //Controllo che la nuova password rispetti i requisiti
        if (!checkPassword(nuovaPassword)) {
            setAlertInfo({ type: "warning", text: "La nuova password non rispetta i requisiti", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            setNuovaPassword('');
            setConfermaPassword('');
            return;
        }

        //Controllo che la nuova password e la conferma password siano uguali
        if (nuovaPassword !== confermaPassword) {
            setAlertInfo({ type: "warning", text: "La nuova password e la conferma password non sono uguali", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            setNuovaPassword('');
            setConfermaPassword('');
            return;
        }

        //Confermo
        try {
            const response = await fetch('/aggiornaPassword', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ID: infoUtente["ID"], Password: nuovaPassword }),
            });


            if (response.status === 200) {
                setIsChangePasswordOpen(false);
                setVecchiaPassword('');
                setNuovaPassword('');
                setConfermaPassword('');
            }
            else {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante l'aggiornamento della password", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }
    };

    return (
        <>
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <footer className="fixed bottom-0 left-0 right-0 bg-gray-200 dark:bg-neutral-800 py-4 px-12">
                <div className="flex justify-between">
                    <button
                        className='text-blue-600 '
                        onClick={() => navigate("/utente/dash")}
                    >
                        <House size={40} />
                    </button>

                    <div className="relative">
                        <button
                            onClick={() => {
                                if (window.location.pathname !== '/utente/articolo') {
                                    navigate('/utente/articolo');
                                }
                                else {
                                    window.location.reload();
                                }
                            }}
                            className="absolute -top-12 left-1/2 transform -translate-x-1/2 p-6 bg-gray-200 dark:bg-neutral-800 text-blue-600 rounded-full shadow-md"
                        >
                            <QrCode size={70} />
                        </button>
                    </div>
                    <button
                        className='text-blue-600'
                        onClick={async () => {
                            if (!infoUtente["Nome"] || !infoUtente["Cognome"] || !infoUtente["Email"]) {
                                await loadFooter();
                            }
                            setIsProfiloOpen(true);
                        }}
                    >
                        <User size={40} />
                    </button>
                </div>
                <PopUp title="Profilo"
                    isVisible={isProfiloOpen}
                    setIsVisible={setIsProfiloOpen}
                    needConfirm={false}
                >
                    <>
                        <div className="flex flex-col items-center">
                            <div className="w-[80%] md:w-[70%] mt-3">
                                <p className="flex justify-between">
                                    Nome :
                                    <span className="font-semibold">{infoUtente["Nome"]}</span>
                                </p>
                                <p className="flex justify-between mt-1">
                                    Cognome :
                                    <span className="font-semibold">{infoUtente["Cognome"]}</span>
                                </p>
                                <p className="flex justify-between mt-1">
                                    Email :
                                    <span className="font-semibold">{infoUtente["Email"]}</span>
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 mt-2">
                            <button className="text-xs md:text-base flex items-center justify-center border-2 border-blue-600 text-blue-600 font-medium py-2 px-2 md:px-4 rounded-lg mr-2 hover:cursor-pointer hover:bg-gray-200 hover:dark:bg-neutral-800" onClick={() => {
                                setNome(infoUtente["Nome"]);
                                setCognome(infoUtente["Cognome"]);
                                setEmail(infoUtente["Email"]);
                                setIsEditProfileOpen(true);
                            }}>
                                MODIFICA PROFILO <UserPen size={20} className="inline ml-1" />
                            </button>
                            <button className="text-xs md:text-base flex items-center justify-center border-2 border-blue-600 text-blue-600 font-medium py-2 px-2 md:px-4 rounded-lg mr-2 hover:cursor-pointer hover:bg-gray-200 hover:dark:bg-neutral-800" onClick={() => setIsChangePasswordOpen(true)}>
                                CAMBIA PASSWORD <KeyRound size={20} className="inline ml-1" />
                            </button>
                        </div>
                        <button className="bg-red-600 text-white font-medium py-2 px-4 rounded-lg hover:cursor-pointer mt-2 flex justify-center items-center w-full" onClick={handleLogout}>
                            LOGOUT
                            <LogOut size={20} className="inline ml-2" />
                        </button>
                    </>
                </PopUp>
                <PopUp title="Modifica profilo"
                    isVisible={isEditProfileOpen}
                    setIsVisible={setIsEditProfileOpen}
                    needConfirm={true}
                    confirmAction={confirmPopUpProfilo}
                    cancelAction={() => { setIsEditProfileOpen(false); setNome(infoUtente['Nome']); setCognome(infoUtente['Cognome']); setEmail(infoUtente['Email']); }}
                >
                    <>
                        <div className="flex flex-col items-center">
                            <div className="w-[80%] md:w-[70%] mt-3">
                                <Input
                                    label="Nome *"
                                    type="text"
                                    value={nome}
                                    setValue={setNome}
                                />
                                <Input
                                    label="Cognome *"
                                    type="text"
                                    classes="mt-2"
                                    value={cognome}
                                    setValue={setCognome}
                                />
                                <Input
                                    label="Email *"
                                    type="text"
                                    value={email}
                                    classes="mt-2"
                                    setValue={setEmail}
                                    blurAction={checkEmail}
                                />
                            </div>
                        </div>
                    </>
                </PopUp>
                <PopUp title="Cambia password"
                    isVisible={isChangePasswordOpen}
                    setIsVisible={setIsChangePasswordOpen}
                    needConfirm={true}
                    confirmAction={confirmPopUpPassword}
                    cancelAction={() => { setIsChangePasswordOpen(false); setVecchiaPassword(""); setNuovaPassword(""); setConfermaPassword(""); }}
                >
                    <>
                        <div className="flex flex-col items-center">
                            <div className="w-[80%] md:w-[70%] mt-3">
                                <Input
                                    label="Vecchia Password *"
                                    type="password"
                                    value={vecchiaPassword}
                                    setValue={setVecchiaPassword}
                                />
                                <Input
                                    label="Nuova Password *"
                                    value={nuovaPassword}
                                    setValue={setNuovaPassword}
                                    type="password"
                                    info={true}
                                    infotext='La password deve contenere almeno 8 caratteri, di cui almeno una lettera maiuscola, una minuscola, un numero e un carattere speciale ( es. [!@#$%^&*(),.?":{}|<>])'
                                    infopos="l"
                                    classes="mt-2"
                                />
                                <Input
                                    label="Conferma nuova Password *"
                                    type="password"
                                    value={confermaPassword}
                                    setValue={setConfermaPassword}
                                    classes="mt-2"
                                />
                            </div>
                        </div>
                    </>
                </PopUp>
            </footer>
        </>
    );
};

export const loadFooter = async () => {
    const idUser = document.cookie.indexOf('tokenUser') !== -1 ? document.cookie.split('tokenUser=')[1].split(";")[0] : null;
    try {
        const response = await fetch('/getUser', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ IDUser: idUser }),
        });

        const data = await response.json();

        if (response.status === 500) {
            console.log(data.error);
            alert(data.error);
        }
        else {
            infoUtente = data[0];
        }

    } catch (error) {
        console.log(error);
        alert("Errore nell'operazione");
    }
};

export default Footer;